module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.lineView) ? _c('div', {}, [_c('div', {
    staticClass: "overlay",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "form-modal"
  }, [_c('h4', [_vm._v("Add / Update Line/Tower")]), _vm._v(" "), _c('vue-form', {
    staticClass: "formadd_scroll",
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.name),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Line / Tower Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.line.name),
      expression: "line.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cdaName",
      "required": "",
      "placeholder": "Line / Tower Name",
      "maxlength": "45",
      "pattern": "^[A-Za-z0-9].{0,44}$"
    },
    domProps: {
      "value": (_vm.line.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.line, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cdaName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                Line / Tower is required.\n                                            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                Alphabets/Numbers are allowed.\n                                            ")])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Houses"), _c('span', {
    staticClass: "required-field-asterisk"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "houses_wrp"
  }, [_vm._l((_vm.line.houseData), function(house, houseIndex) {
    return _c('div', {
      key: houseIndex,
      staticClass: "flex house_number_wrp"
    }, [_c('div', {
      staticClass: "house_number_boxs"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      class: _vm.fieldClassName(_vm.formstate.houses),
      attrs: {
        "auto-label": ""
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (house.hnNo),
        expression: "house.hnNo"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": "H No.",
        "name": 'line.houseData[' + houseIndex + '][\'hnNo\']',
        "maxlength": "15",
        "pattern": "^[a-zA-Z0-9\\s]{0,25}[^\\s]$"
      },
      domProps: {
        "value": (house.hnNo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(house, "hnNo", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": 'line.houseData[' + houseIndex + '][\'hnNo\']',
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                                                    House number is required.\n                                                ")]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "pattern"
      },
      slot: "pattern"
    }, [_vm._v("\n                                                Alphabets/Numbers are allowed.\n                                            ")])])], 1)], 1), _vm._v(" "), (_vm.subCityAdmin) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.line.houseData.length > 1),
        expression: "line.houseData.length > 1"
      }],
      staticClass: "mr-2 btn gradientbt",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeHouse(houseIndex)
        }
      }
    }, [_vm._v("\n                                        -\n                                    ")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt addmorebtn",
    attrs: {
      "type": "button",
      "disabled": (!_vm.formstate.$valid) && _vm.houseList
    },
    on: {
      "click": function($event) {
        return _vm.addMoreHouses()
      }
    }
  }, [_vm._v("\n                                    +\n                                ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), (_vm.mode == 'create') ? _c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createLine
    }
  }, [_vm._v("\n                                Add\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'edit') ? _c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(
        (_vm.formstate.$dirty || _vm.isRemoveButtonClicked) &&
        _vm.formstate.$valid
      )
    },
    on: {
      "click": _vm.updateLine
    }
  }, [_vm._v("\n                                Update\n                            ")]) : _vm._e()])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.$route.params._id && !_vm.noRecords) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "large-12 columns subcattable",
    staticStyle: {
      "background": "white"
    }
  }, [_c('table', {
    staticClass: "test-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.lineInfo), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.houseData.length))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button edit_del_btn"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          return _vm.editLine(index, item)
        }
      }
    })]), _vm._v(" "), (_vm.subCityAdmin) ? _c('button', {
      staticClass: "button edit_del_btn"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      on: {
        "click": function($event) {
          return _vm.deleteLineModal(item._id)
        }
      }
    })]) : _vm._e()])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.$route.params._id && _vm.noRecords) ? _c('div', [_c('h6', [_vm._v("No matching records")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "text-right add_subcategory",
    on: {
      "click": function($event) {
        return _vm.addLine()
      }
    }
  }, [_vm._v("\n            Add Line / Tower\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Line / Tower")]), _vm._v(" "), _c('th', [_vm._v("Houses")]), _vm._v(" "), _c('th', [_vm._v("Action")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c9a885a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteCollectionArea/lineTowerList.vue
// module id = 2368
// module chunks = 1